import React from "react";

interface JsonViewerProps {
  schemaExample: string;
}

const JsonViewer: React.FC<JsonViewerProps> = ({ schemaExample }) => {
  let parsedJson: string;

  try {
    // Step 1: Parse outer escaped JSON string
    const unescaped = JSON.parse(schemaExample); // converts string into object
    // Step 2: Pretty-print
    parsedJson = JSON.stringify(unescaped, null, 2);
  } catch (err) {
    parsedJson = "Invalid JSON";
  }

  return (
    <pre
      style={{
        backgroundColor: "#f5f5f5",
        padding: "1rem",
        borderRadius: "8px",
        overflowX: "auto",
        fontFamily: "monospace",
        fontSize: "0.85rem",
        maxHeight: "300px",
        whiteSpace: "pre-wrap",
        marginBottom: 1.5
      }}
    >
      {parsedJson}
    </pre>
  );
};

export default JsonViewer;